export default "//yastatic.net/s3/distribution/pythia/frontend/_/f0986eab59bc960daea0172ae6c92242.jpeg";